import { render, staticRenderFns } from "./Upsert.vue?vue&type=template&id=fca8b692&"
import script from "./Upsert.vue?vue&type=script&lang=ts&"
export * from "./Upsert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBtnGroup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtnGroup})
